import { z } from "zod";

import { productsPricingResponse } from "@/services/catalogService/contentBundle";
import unauthenticatedHttp from "@/services/unauthenticatedHttp";

import { featuredCardData } from "../marketingManagementService/marquees";
import { popularProduct } from "../middlewareService/popularNewCatalogs";

export async function subscriptions() {
  const { data } = await unauthenticatedHttp().get(`${globalThis.env.API_UNAUTH}/subscriptions`);

  // same shape as catalogService/contentBundle.ts's productPricing() - both feed pricing/setPrices
  return productsPricingResponse.parse(data);
}

export const offersData = z.object({
  active: z.boolean(),
  promotionStartTime: z.string(),
  productIds: z.array(z.string()),
  description: z.string(),
});

export async function unAuthFeaturedOffers() {
  const { data } = await unauthenticatedHttp().get(`${globalThis.env.API_UNAUTH}/featured-offers`);
  if (!data) {
    return;
  }
  return offersData.parse(data);
}

export const featureOptions = z
  .object({
    data: z.array(featuredCardData),
  })
  .strict();

export async function unauthMarketingInfo() {
  const { data } = await unauthenticatedHttp().get(`${globalThis.env.API_UNAUTH}/marketing-info`);
  if (!data) {
    return;
  }
  return featureOptions.parse(data);
}

export const popularNewResponse = z.object({
  popular_catalogs: z.array(popularProduct).nullish(),
  new_catalogs: z.array(popularProduct).nullish(),
});

export async function unauthPopularNew() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/store/popular-new-catalogs`
  );
  if (!data) {
    return;
  }
  return popularNewResponse.parse(data);
}
